<template>
  <div class="album-page">
    <!-- ================= 左侧侧边栏：文件夹树 ================= -->
    <aside class="sidebar">
      <div class="all-albums-header">
        <span class="header-title">全部专辑</span>
        <div class="header-actions">
          <el-tooltip content="搜索文件夹" placement="top">
            <el-icon class="header-icon" @click="ElMessage.info('请输入文件夹名称进行搜索')">
              <Search />
            </el-icon>
          </el-tooltip>
          <el-tooltip content="新建文件夹" placement="top">
            <el-icon class="header-icon" @click="createFolderFun">
              <Plus />
            </el-icon>
          </el-tooltip>
          <el-dropdown trigger="click" @command="headerCommand">
            <el-icon class="header-icon">
              <MoreFilled />
            </el-icon>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="create">新建文件夹</el-dropdown-item>
                <el-dropdown-item command="refresh">刷新树</el-dropdown-item>
                <el-dropdown-item command="collapse">全部折叠</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>

      <!-- 树搜索框 -->
      <el-input placeholder="搜索文件夹" v-model="filterText" clearable size="small"></el-input>

      <!-- 文件夹树 -->
      <el-tree class="folder-tree" ref="treeRef" :data="folderTree" :props="defaultProps"
        :filter-node-method="filterNode" node-key="id" highlight-current :expand-on-click-node="false"
        @node-click="selectFolder">
        <template #default="{ data }">
          <div class="tree-node">
            <span class="tree-node-label">
              <el-icon class="tree-folder-icon">
                <Folder />
              </el-icon>
              <span>{{ data.name }}</span>
            </span>
            <!-- 树节点三点操作 -->
            <el-dropdown trigger="click" @click.stop @command="(cmd) => handleFolderCommand(cmd, data)">
              <span class="more-btn"><el-icon>
                  <MoreFilled />
                </el-icon></span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="create">新建文件夹</el-dropdown-item>
                  <el-dropdown-item command="rename">重命名</el-dropdown-item>
                  <el-dropdown-item command="share">共享</el-dropdown-item>
                  <el-dropdown-item command="move">移动文件夹</el-dropdown-item>
                  <el-dropdown-item command="delete">删除</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </template>
      </el-tree>
    </aside>

    <!-- ================= 右侧主内容区 ================= -->
    <main class="main">
      <!-- 顶部搜索筛选栏 -->
      <div class="toolbar">
        <!-- <el-select v-model="filterForm.albumId" placeholder="专辑" clearable style="width: 160px">
          <el-option v-for="a in allAlbums" :key="a.id" :label="a.name" :value="a.id" />
        </el-select> -->
        <el-input v-model="filterForm.uploaderName" placeholder="上传人(可模糊)" clearable style="width: 160px">
        </el-input>
        <el-input v-model="filterForm.fileName" placeholder="素材名(可模糊)" clearable style="width: 160px">
        </el-input>
        <!-- <el-select v-model="filterForm.projectId" placeholder="项目" clearable style="width: 140px">
          <el-option v-for="p in projects" :key="p.id" :label="p.name" :value="p.id" />
        </el-select> -->
        <el-button @click="searchFun" type="primary">查询</el-button>
        <el-button @click="resetFun">清空</el-button>
        <div class="flex-spacer"></div>
        <el-tooltip content="" placement="top">
          <el-button @click="openorgMyListFun()" type="warning">绑定组织和授权部门（素材数据拉取）</el-button>
          <el-button @click="refreshFun">刷新</el-button>
        </el-tooltip>
      </div>

      <!-- 操作按钮行 -->
      <div class="action-bar">
        <el-button type="primary" :icon="Upload" @click="uploadViewFun()">上传素材</el-button>
        <!-- <el-dropdown @command="createCommand">
          <el-button type="primary" plain>
            新建<el-icon class="el-icon--right">
              <ArrowDown />
            </el-icon>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="album">新建专辑</el-dropdown-item>
              <el-dropdown-item command="folder">新建文件夹</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown> -->
        <el-button @click="startBatchManage">批量管理素材</el-button>
        <el-button @click="openUploadLogFun">巨量推送日志</el-button>
        <div class="flex-spacer"></div>
        <!-- <el-button type="warning" plain @click="cleanView = true">清理素材</el-button> -->
      </div>

      <!-- 批量管理操作栏 -->
      <div v-if="batchMode && viewType === 'grid'" class="batch-action-bar">
        <el-button size="mini" @click="cancelBatchManage">取消</el-button>
        <el-button size="mini" @click="selectCurrentPageFun">选中本页</el-button>
        <span class="batch-selected-tip" v-if="selectedMaterialIds.length > 0">已选 {{ selectedMaterialIds.length }}
          项</span>
        <el-button size="mini" type="primary" @click="batchPushFun">推送到账户/组织</el-button>
        <el-button size="mini" type="danger" @click="batchDeleteFun">删除</el-button>
        <el-button size="mini" @click="deselectCurrentPageFun">取消选中</el-button>
      </div>

      <!-- 视图切换控件 -->
      <div class="view-bar">
        <!-- <el-select v-model="sortOrder" size="small" style="width: 130px" @change="getAlbumListFun">
          <el-option label="创建时间" value="createTime" />
          <el-option label="名称" value="name" />
          <el-option label="资源数量" value="count" />
        </el-select> -->
        <el-radio-group v-model="viewType" size="small">
          <!-- <el-radio-button label="folder">
            <el-tooltip content="文件夹视图"><el-icon>
                <FolderOpened />
              </el-icon></el-tooltip>
          </el-radio-button> -->
          <!-- <el-radio-button label="grid">
            <el-tooltip content="网格视图"><el-icon>
                <Grid />
              </el-icon></el-tooltip>
          </el-radio-button> -->
          <!-- <el-radio-button label="list">
            <el-tooltip content="列表视图"><el-icon>
                <List />
              </el-icon></el-tooltip>
          </el-radio-button> -->
        </el-radio-group>
      </div>

      <!-- ========== 文件夹卡片视图（默认） ========== -->
      <!-- <div v-show="viewType === 'folder'" class="card-grid" v-loading="loading">
        <div class="album-card" v-for="item in albumList" :key="item.id" @click="openAlbum(item)">
          <span class="album-tag">{{ item.uploaderName }}</span>
          <div class="album-cover">
            <img :src="item.cover" @error="onCoverError" />
          </div>
          <div class="album-name" :title="item.name">{{ item.name }}</div>
          <div class="album-meta">
            <span class="meta-count">{{ item.resourceCount }}</span>
            <span class="meta-sep">|</span>
            <span class="meta-size">{{ item.size }}</span>
          </div>
        </div>
      </div> -->

      <!-- ========== 网格视图（素材） ========== -->
      <div v-show="viewType === 'grid'" class="card-grid" v-loading="loading">
        <div class="material-card" v-for="m in materialList" :key="m.id"
          :class="{ 'is-selected': batchMode && selectedMaterialIds.includes(m.id) }" @click="toggleMaterialSelect(m)">
          <el-checkbox v-if="batchMode" class="material-check" :model-value="selectedMaterialIds.includes(m.id)"
            @click.stop />
          <div class="material-cover">
            <img :src="m.cover" @error="onCoverError" />
            <span class="material-duration" v-if="m.duration">{{ m.duration }}</span>
          </div>
          <div class="material-info">
            <div class="material-name" :title="m.name">{{ m.name }}</div>
            <div class="material-meta">{{ m.size }} · {{ m.createTime }}</div>
          </div>
        </div>
      </div>

      <!-- ========== 列表视图（素材表格） ========== -->
      <el-table v-show="viewType === 'list'" :data="materialList" v-loading="loading" style="width: 100%"
        empty-text="暂无数据,请点击左边文件夹">
        <el-table-column label="封面" width="90">
          <template #default="{ row }">
            <img :src="row.cover" class="table-cover" @error="onCoverError" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="素材名称" min-width="200" show-overflow-tooltip />
        <el-table-column prop="size" label="大小" width="120" />
        <el-table-column prop="duration" label="时长" width="100" />
        <el-table-column prop="createTime" label="创建时间" width="170" />
        <el-table-column label="操作" width="140">
          <template #default="{ row }">
            <el-button type="text" size="mini" @click="ElMessage.info('预览：' + row.name)">预览</el-button>
            <el-button type="text" size="mini" @click="ElMessage.info('编辑：' + row.name)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination">
        <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :total="total"
          :pagesize="pagesize" :currentPage="currentPage"></pagination>
      </div>

      <!-- ========== 弹窗（仅UI，mock） ========== -->
      <!-- 上传素材 组件每关闭一次就销毁-->
      <el-dialog v-model="uploadView" title="上传素材" width="60%" destroy-on-close>
        <ylyUploadVideo :upData="upData"></ylyUploadVideo>
      </el-dialog>

      <!-- 新建专辑 -->
      <el-dialog v-model="createAlbumView" title="新建专辑" width="30%">
        <el-form label-width="90px">
          <el-form-item label="专辑名称：">
            <el-input v-model="albumForm.name" placeholder="请输入专辑名称" />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="createAlbumView = false">取消</el-button>
          <el-button type="primary" @click="ElMessage.success('新建专辑为UI占位，接口待接入')">确定</el-button>
        </template>
      </el-dialog>

      <!-- 批量管理素材 -->


      <!-- 清理素材 -->
      <el-dialog v-model="cleanView" title="清理素材" width="30%">
        <el-empty description="清理素材功能，接口待接入" />
        <template #footer>
          <el-button @click="cleanView = false">关闭</el-button>
        </template>
      </el-dialog>

      <!-- 移动文件夹 -->
      <el-dialog v-model="moveView" title="移动文件夹" width="30%">
        <div class="move-dialog">
          <div class="move-root" :class="{ active: targetFolderId === -1 }" @click="selectMoveTarget(-1, '根目录')">
            <el-icon class="tree-folder-icon">
              <Folder />
            </el-icon>
            <span>根目录</span>
          </div>
          <el-tree class="move-tree" :data="folderTree" :props="defaultProps" node-key="id" default-expand-all
            :expand-on-click-node="false" @node-click="onMoveTreeNodeClick">
            <template #default="{ data }">
              <div class="move-tree-node" :class="{ active: targetFolderId === data.id }">
                <el-icon class="tree-folder-icon">
                  <Folder />
                </el-icon>
                <span>{{ data.name }}</span>
              </div>
            </template>
          </el-tree>
        </div>
        <template #footer>
          <el-button @click="moveView = false">取消</el-button>
        </template>
      </el-dialog>

      <!-- 推送到账户或者组织 -->
      <el-dialog v-model="uploadJLView" title="推送到巨量" width="78%">
        <ylyUploadjuliang :Data="selectedMaterialIds"></ylyUploadjuliang>
      </el-dialog>

      <!-- 巨量推送日志 -->
      <el-dialog v-model="uploadLogView" title="巨量推送日志" width="92%" destroy-on-close>
        <div style="display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap;">
          <el-input v-model="uploadLogForm.filename" placeholder="文件名称(模糊查询)" clearable style="width: 200px" />
          <el-input v-model="uploadLogForm.videoMaterialId" placeholder="巨量素材ID(精确查询)" clearable style="width: 200px" />
          <el-select v-model="uploadLogForm.status" placeholder="本地任务状态" clearable style="width: 180px">
            <el-option label="全部" :value="''" />
            <el-option label="创建中" :value="0" />
            <el-option label="处理中" :value="1" />
            <el-option label="成功" :value="2" />
            <el-option label="失败" :value="3" />
          </el-select>
          <el-button type="primary" @click="searchUploadLogFun">查询</el-button>
          <el-button @click="resetUploadLogFun">重置</el-button>
        </div>
        <el-table :data="uploadLogList" v-loading="uploadLogLoading" style="width: 100%" empty-text="暂无数据">
          <el-table-column prop="filename" label="文件名称" min-width="180" show-overflow-tooltip>
            <template #default="{ row }">
              <div>{{ row.filename || '-' }}</div>
              <div style="color: #909399; font-size: 12px;">任务ID：{{ row.taskId || '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="封面" width="150">
            <template #default="{ row }">
              <img :src="row.coverUrl" class="table-cover table-cover-large" @error="onCoverError" />
            </template>
          </el-table-column>
          <el-table-column prop="accountId" label="推送组织/账户" width="180" show-overflow-tooltip>
            <template #default="{ row }">
              <div>{{ row.accountId || '-' }}</div>
              <div style="color: #909399; font-size: 12px;">
                <span v-if="row.accountType === 'EBP'">组织</span>
                <span v-else-if="row.accountType === 'ADVERTISER'">账户</span>
                <span v-else>{{ row.accountType || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="本地任务状态" width="110">
            <template #default="{ row }">
              <el-tag v-if="row.status === 0" type="info">创建中</el-tag>
              <el-tag v-else-if="row.status === 1" type="warning">处理中</el-tag>
              <el-tag v-else-if="row.status === 2" type="success">成功</el-tag>
              <el-tag v-else-if="row.status === 3" type="danger">失败</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="retryCount" label="重试次数" width="90" />
          <el-table-column prop="videoMaterialId" label="巨量素材ID" width="170" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.videoMaterialId || row.videoId || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="errorMsg" label="错误信息" min-width="220" show-overflow-tooltip>
            <template #default="{ row }">
              <span style="color: #f56c6c;">{{ row.errorMsg || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="170" show-overflow-tooltip />
        </el-table>
        <div style="display: flex; justify-content: flex-end; margin-top: 12px;">
          <pagination @handleSizeChange="handleUploadLogSizeChange" @handleCurrentChange="handleUploadLogCurrentChange"
            :total="uploadLogTotal" :pagesize="uploadLogPageSize" :currentPage="uploadLogCurrentPage"></pagination>
        </div>
        <template #footer>
          <el-button @click="uploadLogView = false">关闭</el-button>
        </template>
      </el-dialog>

      <!-- 删除素材 -->
      <el-dialog v-model="deleteSCView" title="删除素材" width="20%">

        <el-form>
          <el-form-item>
            <font style="color:red">确定删除选中的素材？</font>
          </el-form-item>
          <el-form-item>
            <el-button @click="sucaideleteByIdsFun()" type="danger" size="mini">确定</el-button>
          </el-form-item>

        </el-form>
      </el-dialog>

      <!-- 绑定组织和授权部门 -->
      <el-dialog v-model="org.orgMyListView" title="绑定组织和授权部门" width="78%" destroy-on-close>
        <div style="margin-bottom: 12px; display: flex; gap: 8px;">
          <el-button type="primary" @click="openOrgsaveFun">添加组织</el-button>
          <el-button @click="refreshOrgMyListFun">刷新</el-button>
        </div>
        <el-table :data="org.OrgTableData" style="width: 100%" empty-text="暂无绑定组织">
          <el-table-column label="创建人" width="110" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.config ? row.config.createByName : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="组织名称" min-width="180" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.config ? row.config.teamName : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="组织Id" width="180" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.config ? row.config.teamId : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="备注" min-width="140" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.config ? row.config.remark : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="170" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.config ? row.config.createTime : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="类型" width="110">
            <template #default="{ row }">
              <span v-if="row.owner" style="color: #67c23a;">自己创建</span>
              <span v-else style="color: #f56c6c;">他人共享</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260" fixed="right">
            <template #default="{ row }">
              <el-button type="text" size="mini" @click="openOrgShareScopeFun(row)">查看共享范围</el-button>
              <el-button type="text" size="mini" @click="openOrgShareFun(row)">授权部门</el-button>
              <el-button type="text" size="mini" style="color: #f56c6c;" @click="openOrgDeleteFun(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <!-- 添加组织 -->
      <el-dialog v-model="org.orgsaveView" title="添加组织" width="30%" append-to-body destroy-on-close>
        <el-form label-width="90px">
          <el-form-item label="组织ID：">
            <el-input v-model="org.teamId" placeholder="请输入组织ID(teamId)" clearable />
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="org.remark" placeholder="请输入备注" clearable />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="org.orgsaveView = false">取消</el-button>
          <el-button type="primary" @click="confirmOrgsaveFun">确定</el-button>
        </template>
      </el-dialog>

      <!-- 授权部门（单选，必须点击部门后才能确定） -->
      <el-dialog v-model="org.orgShareView" title="授权部门" width="30%" append-to-body destroy-on-close>
        <div style="margin-bottom: 8px; font-size: 13px; color: #909399;">
          请单击选择要共享的部门（单选）
        </div>
        <div style="margin-bottom: 8px; font-size: 13px;">
          已选部门：{{ org.shareDeptName || '未选择' }}
        </div>
        <el-tree ref="orgShareTreeRef" :data="org.DeptData" :props="{ children: 'children', label: 'label' }"
          node-key="id" default-expand-all highlight-current :expand-on-click-node="false"
          @node-click="handleOrgShareDeptClick" />
        <template #footer>
          <el-button @click="org.orgShareView = false">取消</el-button>
          <el-button type="primary" :disabled="org.shareDeptIds.length === 0"
            @click="confirmOrgDeptShareFun">确定</el-button>
        </template>
      </el-dialog>

      <!-- 查看共享范围 -->
      <el-dialog v-model="org.orgShareScopeView" title="共享范围" width="30%" append-to-body destroy-on-close>
        <div v-if="org.shareScopeDepts && org.shareScopeDepts.length > 0">
          <el-tag v-for="item in org.shareScopeDepts" :key="item.deptId" closable style="margin: 0 8px 8px 0;"
            @close="openOrgShareCancelFun(item)">
            {{ item.deptId }}-{{ item.deptName }}
          </el-tag>
        </div>
        <el-empty v-else description="暂无共享部门" />
        <template #footer>
          <el-button @click="org.orgShareScopeView = false">关闭</el-button>
        </template>
      </el-dialog>

      <!-- 取消共享确认 -->
      <el-dialog v-model="org.orgShareCancelView" title="取消共享" width="30%" append-to-body destroy-on-close>
        <p>是否确定取消共享{{ org.cancelShareDeptName }}？</p>
        <template #footer>
          <el-button @click="org.orgShareCancelView = false">取消</el-button>
          <el-button type="danger" @click="confirmOrgShareCancelFun">确定</el-button>
        </template>
      </el-dialog>

      <!-- 删除组织确认 -->
      <el-dialog v-model="org.orgMyDeleteView" title="删除组织" width="30%" append-to-body destroy-on-close>
        <p>确定要删除《{{ org.deRemark }}》？</p>
        <template #footer>
          <el-button @click="org.orgMyDeleteView = false">取消</el-button>
          <el-button type="danger" @click="confirmOrgDeleteFun">确定</el-button>
        </template>
      </el-dialog>

      <!-- 共享文件夹 -->
      <el-dialog v-model="shareView" title="共享" width="80%">
        <el-tabs v-model="shareActiveName" @tab-click="handleShareTabChange">
          <el-tab-pane label="组织共享" name="org">
            <div class="share-tab-wrap">
              <el-row :gutter="12">
                <el-col :span="12">
                  <el-card shadow="never" class="share-card">
                    <template #header>
                      <div class="share-card-title">组织树</div>
                    </template>
                    <el-tree class="share-tree" :data="shareDeptTree" :props="{ children: 'children', label: 'label' }"
                      node-key="id" default-expand-all :expand-on-click-node="false" highlight-current
                      @node-click="handleShareDeptClick">
                      <template #default="{ data }">
                        <div class="share-tree-node">
                          <el-icon class="tree-folder-icon">
                            <Folder />
                          </el-icon>
                          <span>{{ data.label }}</span>
                        </div>
                      </template>
                    </el-tree>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card shadow="never" class="share-card">
                    <template #header>
                      <div class="share-card-title flex-between">
                        <span>当前文件夹共享记录</span>
                        <span>共 {{ shareFolderShareList.length }} 条</span>
                      </div>
                    </template>
                    <el-table v-if="shareFolderShareList.length > 0" :data="shareFolderShareList" size="small"
                      style="width: 100%" empty-text="暂无共享记录">
                      <el-table-column prop="targetName" label="共享部门" min-width="120" show-overflow-tooltip />
                      <el-table-column label="共享类型" width="100">
                        <template #default="{ row }">
                          {{ row.shareType == 1 ? '部门共享' : '个人共享' }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="createByName" label="创建人" width="100" show-overflow-tooltip />
                      <el-table-column prop="createTime" label="创建时间" width="170" />
                      <el-table-column label="操作" width="100">
                        <template #default="{ row }">
                          <el-button type="text" size="mini" @click="deleteShareFun(row)">取消共享</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-empty v-else description="暂无共享记录" />
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="用户共享" name="user">
            <div class="share-tab-wrap">
              <el-row :gutter="12">
                <el-col :span="8">
                  <el-card shadow="never" class="share-card">
                    <template #header>
                      <div class="share-card-title">部门树</div>
                    </template>
                    <el-tree class="share-tree" :data="shareDeptTree" :props="{ children: 'children', label: 'label' }"
                      node-key="id" default-expand-all :expand-on-click-node="false" highlight-current
                      @node-click="handleShareDeptClick">
                      <template #default="{ data }">
                        <div class="share-tree-node">
                          <el-icon class="tree-folder-icon">
                            <Folder />
                          </el-icon>
                          <span>{{ data.label }}</span>
                        </div>
                      </template>
                    </el-tree>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="never" class="share-card">
                    <template #header>
                      <div class="share-card-title flex-between">
                        <span>用户名称</span>
                        <el-input v-model="shareUserKeyword" placeholder="姓名/用户名模糊查询" clearable size="small"
                          style="width: 220px" @input="handleShareUserKeywordChange" />
                      </div>
                    </template>

                    <div class="share-selected-tip">已选部门：{{ shareTargetDeptName || '未选择' }}</div>
                    <div class="share-user-select-title">点击部门后查询的人员</div>
                    <div v-if="shareUserList.length > 0" class="share-user-select-wrap">
                      <el-checkbox-group v-model="shareUserSelectedIds">
                        <div class="share-user-item" v-for="item in shareUserList" :key="item.id">
                          <el-checkbox :label="item.id">
                            {{ item.nickName || item.username }}
                            <span class="share-user-sub">（{{ item.deptName }}）</span>
                          </el-checkbox>
                        </div>
                      </el-checkbox-group>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="10">
                  <el-card shadow="never" class="share-card">
                    <template #header>
                      <div class="share-card-title">已共享人</div>
                    </template>
                    <el-table v-if="shareUserShareList.length > 0" :data="shareUserShareList" size="small"
                      style="width: 100%" empty-text="暂无共享人员">
                      <el-table-column prop="targetName" label="已共享人" min-width="120" show-overflow-tooltip />
                      <el-table-column prop="createByName" label="创建人" width="100" show-overflow-tooltip />
                      <el-table-column prop="createTime" label="创建时间" width="170" />
                      <el-table-column label="操作" width="100">
                        <template #default="{ row }">
                          <el-button type="text" size="mini" @click="deleteShareFun(row)">取消共享</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-empty v-else description="暂无共享人员数据" />
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
        <template #footer>
          <el-button @click="closeShareView">关闭</el-button>
          <el-button v-if="shareActiveName == 'org'" type="primary" @click="confirmOrgShareFun">确定共享</el-button>
          <el-button v-if="shareActiveName == 'user'" type="primary" @click="confirmUserShareFun">确定共享</el-button>
        </template>
      </el-dialog>
    </main>
  </div>
</template>

<script>
import {
  foldercreate,
  foldertree,
  folderupdate,
  folderdeptTree,
  folderdeptUsers,
  foldershareSave,
  foldershareDelete,
  foldershareList,
  folderdelete,
  sucaiSelectList,
  sucaideleteByIds,
  juliangmeitivideopullSave,
  juliangmeitivideopullShare,
  juliangmeitivideopullmylist,
  juliangmeitivideopullDelete,
  juliangmeitivideopullUnshare,
  sucaijuliangvideopushRecords
} from '@/request/new/ylyBatch'
import { ElMessage, ElMessageBox } from 'element-plus'
import { reactive, toRefs, watch, ref } from 'vue'
import { Refresh, Upload, Search, User } from '@element-plus/icons-vue'
import pagination from '@/components/pagination.vue' // 导入分页组件
import ylyUploadVideo from '@/components/ylyBatch/ylyUploadVideo.vue' // 导入上传组件
import ylyUploadjuliang from '@/components/ylyBatch/ylyUploadjuliang.vue' // 导入巨量推送组件


export default {
  name: 'sucaiListPage',
  components: { pagination, ylyUploadVideo, ylyUploadjuliang },
  setup() {
    //模板ref，不能放进reactive
    const treeRef = ref(null)
    const orgShareTreeRef = ref(null)

    const state = reactive({
      // ==========分页相关==========
      pagesize: 20,
      currentPage: 1,
      total: 0,
      // 分页切换
      handleCurrentChange: (e) => {
        state.currentPage = e
        state.getAlbumListFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        state.getAlbumListFun()
      },

      // ==========视图与排序==========
      viewType: 'grid', // folder / list / grid
      sortOrder: 'createTime',
      loading: false,

      // ==========筛选条件==========
      filterForm: {
        // albumId: '',
        // keyword: '',
        // projectId: '',
        fileName: '',
        uploaderName: '',
      },

      // ==========数据==========
      selectedFolderId: '', // 当前选中的文件夹id
      albumsAll: [], // 当前文件夹下的全部专辑（未分页）
      albumList: [], // 分页后的专辑列表
      materialList: [], // 素材列表（网格/列表视图）
      allAlbums: [], // 全部专辑（下拉选项）
      projects: [], // 项目下拉选项

      // ==========上传组件的数据==========
      upData: {},
      // ==========巨量推送日志==========
      uploadLogView: false,
      uploadLogLoading: false,
      uploadLogList: [],
      uploadLogTotal: 0,
      uploadLogCurrentPage: 1,
      uploadLogPageSize: 20,
      uploadLogForm: {
        filename: '',
        videoMaterialId: '',
        status: '',
      },
      openUploadLogFun: () => {
        state.uploadLogView = true
        state.uploadLogCurrentPage = 1
        state.fetchUploadLogFun()
      },
      searchUploadLogFun: () => {
        state.uploadLogCurrentPage = 1
        state.fetchUploadLogFun()
      },
      resetUploadLogFun: () => {
        state.uploadLogForm.filename = ''
        state.uploadLogForm.videoMaterialId = ''
        state.uploadLogForm.status = ''
        state.uploadLogCurrentPage = 1
        state.fetchUploadLogFun()
      },
      handleUploadLogCurrentChange: (e) => {
        state.uploadLogCurrentPage = e
        state.fetchUploadLogFun()
      },
      handleUploadLogSizeChange: (e) => {
        state.uploadLogPageSize = e
        state.uploadLogCurrentPage = 1
        state.fetchUploadLogFun()
      },
      fetchUploadLogFun: () => {
        state.uploadLogLoading = true
        const datas = {
          filename: state.uploadLogForm.filename || undefined,
          videoMaterialId: state.uploadLogForm.videoMaterialId || undefined,
          currenPage: state.uploadLogCurrentPage,
          pageSize: state.uploadLogPageSize,
        }
        if (state.uploadLogForm.status !== '' && state.uploadLogForm.status !== null && state.uploadLogForm.status !== undefined) {
          datas.status = state.uploadLogForm.status
        }
        sucaijuliangvideopushRecords(datas).then((res) => {
          if (res.code == 200) {
            const data = res.data || {}
            state.uploadLogList = data.data || data.list || data.records || []
            state.uploadLogTotal = data.totalSize || data.total || data.totalCount || state.uploadLogList.length
          } else {
            ElMessage.error(res.msg)
          }
        }).catch(() => {
          ElMessage.error('巨量推送日志查询失败')
        }).finally(() => {
          state.uploadLogLoading = false
        })
      },
      // ==========弹窗控制==========
      uploadView: false,
      createAlbumView: false,
      batchMode: false,
      selectedMaterialIds: [],
      cleanView: false,
      moveView: false,
      shareView: false,
      uploadJLView: false,
      deleteSCView: false,
      shareActiveName: 'org',
      sourceFolderData: null,
      targetFolderId: null,
      targetFolderName: '',
      shareDeptTree: [],
      shareDeptTargetList: [],
      shareUserList: [],
      shareUserKeyword: '',
      shareDeptSelectedIds: [],
      shareUserSelectedIds: [],
      shareTargetDeptId: null,
      shareTargetDeptName: '',
      shareFolderShareList: [],
      shareUserShareList: [],
      shareQueryType: 1,
      albumForm: {
        name: '',
      },

      // ==========树相关参数==========
      filterText: '',
      folderTree: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      // ==========绑定组织和授权部门相关参数==========
      org: {
        // 查看可见组织弹窗
        orgMyListView: false,
        // 共享组织给部门弹窗
        orgShareView: false,
        // 查看共享范围弹窗
        orgShareScopeView: false,
        // 查看共享范围的数据：shareDepts 数组，形如 [{deptId: 44, deptName: "技术部"}]
        shareScopeDepts: [],
        // 查看共享范围的组织配置ID（用于取消共享）
        shareScopeConfigId: '',
        // 取消共享确认弹窗
        orgShareCancelView: false,
        // 待取消共享的部门id
        cancelShareDeptId: '',
        // 待取消共享的部门名称
        cancelShareDeptName: '',
        // 删除组织弹窗
        orgMyDeleteView: false,
        // 添加组织弹窗
        orgsaveView: false,
        // 要添加的组织ID
        teamId: '',
        // 要添加的组织ID备注
        remark: '',
        // 选中的组织ID
        configId: '',
        // 选中的部门id（单选，只存一个）
        shareDeptIds: [],
        // 选中的部门名称（单选回显）
        shareDeptName: '',
        // 查询的组织数据
        OrgTableData: [],
        // 查询的部门数据
        DeptData: [],
        // 要删除id
        key: '',
        // 要删除备注
        deRemark: '',
      },
      // 点击查询绑定组织和授权部门
      openorgMyListFun: () => {
        state.refreshOrgMyListFun()
      },
      // 刷新可见组织列表
      refreshOrgMyListFun: () => {
        juliangmeitivideopullmylist().then((res) => {
          if (res.code == 200) {
            state.org.OrgTableData = res.data || []
            // 打开弹窗
            state.org.orgMyListView = true
          } else {
            ElMessage.error(res.msg)
          }
        }).catch(() => {
          ElMessage.error('查询绑定组织失败')
        })
      },
      // 打开添加组织弹窗
      openOrgsaveFun: () => {
        state.org.teamId = ''
        state.org.remark = ''
        state.org.orgsaveView = true
      },
      // 确认添加组织：body{"teamId": xxx, "remark": "备注"}
      confirmOrgsaveFun: () => {
        if (!state.org.teamId) {
          ElMessage.error('请输入组织ID')
          return
        }
        const datas = {
          teamId: state.org.teamId,
          remark: state.org.remark,
        }
        juliangmeitivideopullSave(datas).then((res) => {
          if (res.code == 200) {
            ElMessage.success('添加组织成功')
            state.org.orgsaveView = false
            state.refreshOrgMyListFun()
          } else {
            ElMessage.error(res.msg)
          }
        }).catch(() => {
          ElMessage.error('添加组织失败')
        })
      },
      // 打开授权部门弹窗：每次打开清空选择，必须重新点击部门后才能确定
      openOrgShareFun: (row) => {
        state.org.configId = row.config ? row.config.id : row.id
        state.org.shareDeptIds = []
        state.org.shareDeptName = ''
        state.org.orgShareView = true
        state.getOrgDeptTreeFun()
      },
      // 授权部门树单选点击：只保留当前点击节点
      handleOrgShareDeptClick: (data) => {
        state.org.shareDeptIds = [data.id]
        state.org.shareDeptName = data.label
        if (orgShareTreeRef.value) {
          orgShareTreeRef.value.setCurrentKey(data.id)
        }
      },
      // 查看共享范围：弹窗显示当前行 shareDepts，展示部门id和部门名称
      openOrgShareScopeFun: (row) => {
        state.org.shareScopeConfigId = row.config ? row.config.id : row.id
        state.org.shareScopeDepts = row.shareDepts || []
        state.org.orgShareScopeView = true
      },
      // 打开取消共享确认弹窗：记录待取消的部门id和名称
      openOrgShareCancelFun: (item) => {
        state.org.cancelShareDeptId = item.deptId
        state.org.cancelShareDeptName = item.deptName
        state.org.orgShareCancelView = true
      },
      // 确认取消共享：body{"configId": 行id, "shareDeptIds": [点击的共享部门id]}
      confirmOrgShareCancelFun: () => {
        if (!state.org.shareScopeConfigId) {
          ElMessage.error('缺少组织ID，无法取消共享')
          return
        }
        if (state.org.cancelShareDeptId === '' || state.org.cancelShareDeptId === null || state.org.cancelShareDeptId === undefined) {
          ElMessage.error('缺少部门ID，无法取消共享')
          return
        }
        const datas = {
          configId: state.org.shareScopeConfigId,
          shareDeptIds: [state.org.cancelShareDeptId],
        }
        juliangmeitivideopullUnshare(datas).then((res) => {
          if (res.code == 200) {
            ElMessage.success('已取消共享' + (state.org.cancelShareDeptName || ''))
            state.org.orgShareCancelView = false
            // 本地先移除该部门标签，避免等待刷新
            state.org.shareScopeDepts = (state.org.shareScopeDepts || []).filter(
              (item) => item.deptId !== state.org.cancelShareDeptId
            )
            state.org.cancelShareDeptId = ''
            state.org.cancelShareDeptName = ''
            // 同步刷新主表格数据，保持一致
            juliangmeitivideopullmylist().then((listRes) => {
              if (listRes.code == 200) {
                state.org.OrgTableData = listRes.data || []
                const current = (state.org.OrgTableData || []).find((row) => {
                  const rowId = row.config ? row.config.id : row.id
                  return rowId === state.org.shareScopeConfigId
                })
                if (current) {
                  state.org.shareScopeDepts = current.shareDepts || []
                }
              }
            })
          } else {
            ElMessage.error(res.msg)
          }
        }).catch(() => {
          ElMessage.error('取消共享失败')
        })
      },
      // 查询部门树（复用共享选部门接口）
      getOrgDeptTreeFun: () => {
        folderdeptTree({}).then((res) => {
          if (res.code == 200) {
            state.org.DeptData = res.data || []
          } else {
            ElMessage.error(res.msg)
          }
        })
      },
      // 确认授权部门（单选，必须先点击部门）：body{"configId": 1, "shareDeptIds": [10]}
      confirmOrgDeptShareFun: () => {
        if (!state.org.shareDeptIds || state.org.shareDeptIds.length === 0) {
          ElMessage.error('请先点击选择要共享的部门')
          return
        }
        const datas = {
          configId: state.org.configId,
          shareDeptIds: state.org.shareDeptIds || [],
        }
        juliangmeitivideopullShare(datas).then((res) => {
          if (res.code == 200) {
            ElMessage.success('授权成功')
            state.org.orgShareView = false
            state.refreshOrgMyListFun()
          } else {
            ElMessage.error(res.msg)
          }
        }).catch(() => {
          ElMessage.error('授权失败')
        })
      },
      // 打开删除组织确认弹窗：行 id 绑定 org.key，teamName 绑定 org.deRemark
      openOrgDeleteFun: (row) => {
        state.org.key = row.config ? row.config.id : row.id
        state.org.deRemark = row.config ? row.config.teamName : (row.teamName || '')
        state.org.orgMyDeleteView = true
      },
      // 确认删除组织：body{"id": 1}，仅添加人可删
      confirmOrgDeleteFun: () => {
        juliangmeitivideopullDelete({ id: state.org.key }).then((res) => {
          if (res.code == 200) {
            ElMessage.success('删除成功')
            state.org.orgMyDeleteView = false
            state.refreshOrgMyListFun()
          } else {
            ElMessage.error(res.msg)
          }
        }).catch(() => {
          ElMessage.error('删除失败')
        })
      },

      // ==========查询素材列表（分页+筛选）==========
      getAlbumListFun: () => {
        fetchAlbumsFun()
      },

      // ==========点击左侧文件夹==========
      selectFolder: (data) => {
        state.upData = { type: 'sucaiListPage', data: { 'folderId': data.id } }
        console.log('点击左侧文件夹', state.upData)
        state.selectedFolderId = data.id
        state.currentPage = 1
        fetchAlbumsFun()
      },

      // ==========树节点三点操作==========
      handleFolderCommand: (cmd, data) => {
        if (cmd === 'create') {
          state.createFolderFun(data)
        } else if (cmd === 'rename') {
          state.renameFolderFun(data)
        } else if (cmd === 'share') {
          state.shareFolderFun(data)
        } else if (cmd === 'move') {
          state.moveFolderFun(data)
        } else if (cmd === 'delete') {
          state.deleteFolderFun(data)
        }
      },

      // ==========刷新素材列表==========
      refreshFun: () => {
        fetchAlbumsFun()
      },

      // ==========批量管理==========
      startBatchManage: () => {
        state.batchMode = true
        state.selectedMaterialIds = []
      },

      cancelBatchManage: () => {
        state.batchMode = false
        state.selectedMaterialIds = []
      },

      toggleMaterialSelect: (item) => {
        if (!state.batchMode) return
        const index = state.selectedMaterialIds.indexOf(item.id)
        if (index > -1) {
          state.selectedMaterialIds.splice(index, 1)
        } else {
          state.selectedMaterialIds.push(item.id)
        }
      },

      selectCurrentPageFun: () => {
        state.selectedMaterialIds = state.materialList.map((item) => item.id)
      },

      deselectCurrentPageFun: () => {
        const currentIds = new Set(state.materialList.map((item) => item.id))
        state.selectedMaterialIds = state.selectedMaterialIds.filter((id) => !currentIds.has(id))
      },

      batchPushFun: () => {
        if (state.selectedMaterialIds.length === 0) {
          ElMessage.warning('请先选择素材')
          return
        }
        state.uploadJLView = true
      },

      batchDeleteFun: () => {
        if (state.selectedMaterialIds.length === 0) {
          ElMessage.warning('请先选择素材')
          return
        }
        state.deleteSCView = true
      },

      // ==========共享文件夹==========
      shareFolderFun: (data) => {
        state.sourceFolderData = data
        state.shareActiveName = 'org'
        state.shareDeptTree = []
        state.shareDeptTargetList = []
        state.shareUserList = []
        state.shareUserShareList = []
        state.shareDeptSelectedIds = []
        state.shareUserSelectedIds = []
        state.shareTargetDeptId = null
        state.shareTargetDeptName = ''
        state.shareFolderShareList = []
        state.shareUserKeyword = ''
        state.shareQueryType = 1
        state.shareView = true
        state.getShareDeptTreeFun()
        state.getShareFolderShareListFun(1)
      },

      // ==========查询当前登录人部门及其下级部门树(共享选部门)==========
      getShareDeptTreeFun: () => {
        folderdeptTree({}).then((res) => {
          if (res.code == 200) {
            state.shareDeptTree = res.data || []
          } else {
            ElMessage.error(res.msg)
          }
        })
      },

      // ==========查询部门下人员（共享选人）==========
      getShareUserListFun: () => {
        const datas = {
          deptId: state.shareTargetDeptId,
          keyword: state.shareUserKeyword,
        }
        folderdeptUsers(datas).then((res) => {
          if (res.code == 200) {
            state.shareUserList = res.data || []
            // state.shareUserShareList = []
          } else {
            ElMessage.error(res.msg)
          }
        })
      },
      //上传素材按钮
      uploadViewFun: () => {
        if (state.selectedFolderId != '') {
          state.uploadView = true
        } else {
          ElMessage.error('请先在左边选择文件夹')
        }
      },

      // ==========查询文件夹共享列表==========
      getShareFolderShareListFun: (shareType = state.shareQueryType) => {
        if (!state.sourceFolderData) return
        state.shareQueryType = shareType
        foldershareList({
          folderId: state.sourceFolderData.id,
          shareType,
        }).then((res) => {
          if (res.code == 200) {
            state.shareFolderShareList = res.data || []
            if (shareType == 2) {
              // 共享人
              state.shareUserShareList = res.data || []
            }
          } else {
            ElMessage.error(res.msg)
          }
        })
      },

      // ==========组织树点击==========
      handleShareDeptClick: (data) => {
        state.shareTargetDeptId = data.id
        state.shareTargetDeptName = data.label
        state.shareDeptTargetList = [data]
        state.shareDeptSelectedIds = [data.id]
        state.getShareUserListFun()
      },

      // ==========共享人员关键词变化==========
      handleShareUserKeywordChange: () => {
        state.getShareUserListFun()
      },

      // ==========组织共享确认==========
      confirmOrgShareFun: () => {
        if (!state.sourceFolderData) return
        if (state.shareDeptSelectedIds.length == 0) {
          ElMessage.error('请选择共享部门')
          return
        }
        const datas = {
          folderId: state.sourceFolderData.id,
          shareType: 1,
          shareToList: state.shareDeptSelectedIds,
        }
        foldershareSave(datas).then((res) => {
          if (res.code == 200) {
            ElMessage.success('共享成功')
            state.getShareFolderShareListFun(1)
          } else {
            ElMessage.error(res.msg)
          }
        })
      },

      // ==========用户共享确认==========
      confirmUserShareFun: () => {
        if (!state.sourceFolderData) return
        if (state.shareUserSelectedIds.length == 0) {
          ElMessage.error('请选择共享人员')
          return
        }
        const datas = {
          folderId: state.sourceFolderData.id,
          shareType: 2,
          shareToList: state.shareUserSelectedIds,
        }
        foldershareSave(datas).then((res) => {
          if (res.code == 200) {
            ElMessage.success('共享成功')
            state.getShareFolderShareListFun(state.shareQueryType)
          } else {
            ElMessage.error(res.msg)
          }
        })
      },

      // ==========取消共享==========
      deleteShareFun: (row) => {
        ElMessageBox.confirm('确定取消共享吗？', '提示', {
          type: 'warning',
        }).then(() => {
          foldershareDelete({ id: row.id }).then((res) => {
            if (res.code == 200) {
              ElMessage.success('取消共享成功')
              state.getShareFolderShareListFun(state.shareQueryType)
            } else {
              ElMessage.error(res.msg)
            }
          })
        }).catch(() => { })
      },

      // ==========共享弹窗 tab 切换==========
      handleShareTabChange: () => {
        if (state.shareActiveName === 'org') {
          state.getShareFolderShareListFun(1)
        }
        if (state.shareActiveName === 'user') {
          state.getShareFolderShareListFun(2)
          if (state.shareTargetDeptId != null) {
            state.getShareUserListFun()
          }
        }
      },

      // ==========共享关闭==========
      closeShareView: () => {
        state.shareView = false
        state.sourceFolderData = null
        state.shareDeptTree = []
        state.shareDeptTargetList = []
        state.shareUserList = []
        state.shareUserKeyword = ''
        state.shareDeptSelectedIds = []
        state.shareUserSelectedIds = []
        state.shareTargetDeptId = null
        state.shareTargetDeptName = ''
        state.shareFolderShareList = []
      },
      //删除选中素材
      sucaideleteByIdsFun: () => {
        sucaideleteByIds(state.selectedMaterialIds).then((res) => {
          if (res.code == 200) {
            ElMessage.success('删除成功')
            state.deleteSCView = false
            fetchAlbumsFun()
          }
        })
      },
      // ==========重命名文件夹==========
      renameFolderFun: (data) => {
        ElMessageBox.prompt('请输入新的文件夹名称', '重命名文件夹', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: data.name || data.label,
          inputPlaceholder: '请输入文件夹名称',
        }).then(({ value }) => {
          const datas = {
            id: data.id,
            name: value,
            parentId: null,
          }
          folderupdate(datas).then((res) => {
            if (res.code == 200) {
              ElMessage.success('重命名成功')
              state.getFolderTreeFun()
            } else {
              ElMessage.error(res.msg)
            }
          })
        }).catch(() => { })
      },

      // ==========移动文件夹==========
      moveFolderFun: (data) => {
        state.sourceFolderData = data
        state.targetFolderId = null
        state.moveView = true
      },

      // 树/根目录点击选择移动目标
      selectMoveTarget: (target, targetName) => {
        state.targetFolderId = target
        state.targetFolderName = targetName || ''
        ElMessageBox.confirm('确定把文件夹移动到“' + state.targetFolderName + '”吗？', '提示', {
          type: 'warning',
        }).then(() => {
          state.confirmMoveFun()
        }).catch(() => { })
      },

      // 点击移动树节点
      onMoveTreeNodeClick: (data) => {
        state.selectMoveTarget(data.id, data.name)
      },

      // 判断是否禁止移动到自己或自己的子节点
      isInvalidMoveTarget: (targetId) => {
        if (!state.sourceFolderData) return true
        if (targetId === -1) return false
        if (state.sourceFolderData.id === targetId) return true

        const findNodeById = (list = [], id) => {
          for (let i = 0; i < list.length; i++) {
            const item = list[i]
            if (item.id === id) return item
            if (item.children && item.children.length > 0) {
              const result = findNodeById(item.children, id)
              if (result) return result
            }
          }
          return null
        }

        const sourceNode = findNodeById(state.folderTree, state.sourceFolderData.id)
        if (!sourceNode || !sourceNode.children || sourceNode.children.length === 0) return false

        const isDescendant = (list = []) => {
          for (let i = 0; i < list.length; i++) {
            const item = list[i]
            if (item.id === targetId) return true
            if (item.children && item.children.length > 0 && isDescendant(item.children)) return true
          }
          return false
        }

        return isDescendant(sourceNode.children)
      },

      // 确认移动
      confirmMoveFun: () => {
        if (state.targetFolderId === null || state.sourceFolderData === null) {
          ElMessage.error('请选择目标文件夹')
          return
        }
        if (state.isInvalidMoveTarget(state.targetFolderId)) {
          ElMessage.error('不能移动到自己或自己的子目录')
          return
        }
        const datas = {
          id: state.sourceFolderData.id,
          parentId: state.targetFolderId === -1 ? -1 : state.targetFolderId,
        }
        folderupdate(datas).then((res) => {
          if (res.code == 200) {
            ElMessage.success('移动成功')
            state.moveView = false
            state.sourceFolderData = null
            state.targetFolderId = null
            state.targetFolderName = ''
            state.getFolderTreeFun()
          } else {
            ElMessage.error(res.msg)
          }
        })
      },

      // ==========删除文件夹==========
      deleteFolderFun: (data) => {
        ElMessageBox.confirm('确定删除文件夹「' + (data.name || data.label) + '」？将删除其文件夹', '提示', {
          type: 'warning',
        }).then(() => {
          console.log('删除文件夹', data)

          const datas = {
            id: data.id
          }
          folderdelete(datas).then((res) => {
            if (res.code == 200) {
              ElMessage.success('删除成功')
              state.moveView = false
              state.sourceFolderData = null
              state.targetFolderId = null
              state.targetFolderName = ''
              state.getFolderTreeFun()
            } else {
              ElMessage.error(res.msg)
            }
          })

        }).catch(() => { })
      },

      // ==========查询文件夹树==========
      getFolderTreeFun: () => {
        foldertree({}).then((res) => {
          if (res.code == 200) {
            state.folderTree = res.data || []
            state.allAlbums = getAllFoldersFlat(res.data || [])
            if (!state.selectedFolderId && state.folderTree.length > 0) {
              state.selectedFolderId = state.folderTree[0].id
              fetchAlbumsFun()
            }
          } else {
            ElMessage.error(res.msg)
          }
        })
      },

      // ==========共享弹窗关闭==========
      closeShareView: () => {
        state.shareView = false
        state.sourceFolderData = null
        state.shareDeptTree = []
        state.shareDeptTargetList = []
        state.shareUserList = []
        state.shareUserKeyword = ''
        state.shareDeptSelectedIds = []
        state.shareUserSelectedIds = []
        state.shareTargetDeptId = null
        state.shareTargetDeptName = ''
        state.shareFolderShareList = []
      },

      // ==========左侧更多操作==========
      headerCommand: (cmd) => {
        if (cmd === 'create') {
          state.createFolderFun()
        } else if (cmd === 'refresh') {
          getFolderTreeFun()
        } else if (cmd === 'collapse') {
          treeRef.value?.setCurrentKey(null)
        }
      },

      // ==========搜索==========
      searchFun: () => {
        state.currentPage = 1
        state.getAlbumListFun()
      },

      // ==========清空筛选==========
      resetFun: () => {
        // state.filterForm.albumId = ''
        // state.filterForm.keyword = ''
        // state.filterForm.projectId = ''
        state.filterForm.fileName = ''
        state.filterForm.uploaderName = ''
        state.currentPage = 1
        state.getAlbumListFun()
      },

      // ==========新建下拉==========
      createCommand: (cmd) => {
        if (cmd === 'album') {
          state.createAlbumView = true
        } else if (cmd === 'folder') {
          state.createFolderFun()
        }
      },

      // ==========创建文件夹==========
      createFolderFun: (data) => {
        ElMessageBox.prompt('请输入文件夹名称', '新建文件夹', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '请输入文件夹名称',
        }).then(({ value }) => {
          const datas = {
            name: value,
            parentId: data && data.id ? data.id : null,
          }
          foldercreate(datas).then((res) => {
            if (res.code == 200) {
              ElMessage.success('新建成功')
              state.getFolderTreeFun()
            } else {
              ElMessage.error(res.msg)
            }
          })
        }).catch(() => { })
      },

      // ==========打开专辑卡片==========
      openAlbum: (item) => {
        ElMessage.info('打开专辑：' + item.name)
      },

      // ==========封面加载失败兜底==========
      onCoverError: (e) => {
        e.target.style.display = 'none'
      },
    })

    // ================= mock 测试数据 =================
    // 占位图
    const coverUrl = (seed) => 'https://picsum.photos/seed/album' + seed + '/300/200'

    // 项目下拉
    state.projects = [
      { id: 1, name: '项目A' },
      { id: 2, name: '项目B' },
      { id: 3, name: '项目C' },
    ]

    // 素材列表由接口加载
    state.materialList = []

    // 全部专辑（下拉选项）
    state.allAlbums = [

    ]

    // 文件夹树 mock 数据
    state.folderTree = [
      {
        id: 1,
        name: '大盘数据',
        parentId: null,
        level: 0,
        deptId: 44,
        deptName: '技术部',
        children: [
          { id: 11, name: '月度报表', parentId: 1, level: 1, deptId: 44, deptName: '技术部', children: [] },
          { id: 12, name: '竞品分析', parentId: 1, level: 1, deptId: 44, deptName: '技术部', children: [] },
        ],
      },
      {
        id: 2,
        name: '短剧素材',
        parentId: null,
        level: 0,
        deptId: 44,
        deptName: '技术部',
        children: [
          { id: 21, name: '竖屏', parentId: 2, level: 1, deptId: 44, deptName: '技术部', children: [] },
          { id: 22, name: '横屏', parentId: 2, level: 1, deptId: 44, deptName: '技术部', children: [] },
        ],
      },
      { id: 3, name: '广告素材', parentId: null, level: 0, deptId: 44, deptName: '技术部', children: [] },
    ]


    // ================= 查询左侧树（真实接口） =================
    const getFolderTreeFun = () => {
      foldertree({}).then((res) => {
        if (res.code == 200) {
          state.folderTree = res.data || []
        } else {
          ElMessage.error(res.msg)
        }
      })
    }

    // 递归拍平树数据，用于顶部下拉和移动时校验
    const getAllFoldersFlat = (list = [], result = []) => {
      list.forEach((item) => {
        result.push(item)
        if (item.children && item.children.length > 0) {
          getAllFoldersFlat(item.children, result)
        }
      })
      return result
    }

    // ================= 文件大小格式化 =================
    const formatFileSize = (size) => {
      if (!size) return '-'
      if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB'
      if (size < 1024 * 1024 * 1024) return (size / 1024 / 1024).toFixed(2) + ' MB'
      return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
    }

    // ================= 查询素材列表（真实接口） =================
    const fetchAlbumsFun = () => {
      state.loading = true
      const datas = {
        currenPage: state.currentPage,
        currentPage: state.currentPage,
        pageNum: state.currentPage,
        size: state.pagesize,
        pageSize: state.pagesize,
        folderId: state.selectedFolderId || undefined,
        uploaderName: state.filterForm.uploaderName || undefined,
        fileName: state.filterForm.fileName || undefined,
      }
      sucaiSelectList(datas).then((res) => {
        if (res.code == 200) {
          const data = res.data || {}
          const list = data.data || []
          state.materialList = list.map((item) => ({
            ...item,
            name: item.fileName,
            cover: item.coverUrl || item.url,
            size: formatFileSize(item.fileSize),
            duration: '',
          }))
          state.albumList = state.materialList
          state.albumList = state.materialList
          state.total = data.totalSize || data.total || data.totalCount || list.length
          state.currentPage = data.currenPage || data.currentPage || state.currentPage
        } else {
          ElMessage.error(res.msg)
        }
      }).catch(() => {
        ElMessage.error('素材列表查询失败')
      }).finally(() => {
        state.loading = false
      })
    }

    // ================= 树搜索过滤 =================
    const filterNode = (value, data) => {
      if (!value) return true
      return (data.name || data.label || '').indexOf(value) !== -1
    }

    // ================= 监听树搜索 =================
    watch(
      () => state.filterText,
      (val) => {
        treeRef.value?.filter(val)
      }
    )

    // 移动弹窗树内点击要能拿到节点名称
    state.targetFolderName = ''

    // 初始化：加载文件夹树和素材列表
    getFolderTreeFun()
    // fetchAlbumsFun()

    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      Refresh,
      Upload,
      Search,
      User,
      fetchAlbumsFun,
      filterNode,
      treeRef,
      orgShareTreeRef,
      getFolderTreeFun,
      getAllFoldersFlat,
    }
  },
}
</script>

<style lang="scss" scoped>
.album-page {
  display: flex;
  height: calc(100vh - 60px);
  background: #fff;
  border-radius: 6px;
  overflow: hidden;

  .flex-spacer {
    flex: 1;
  }
}

/* ================= 左侧侧边栏 ================= */
.sidebar {
  width: 260px;
  flex-shrink: 0;
  border-right: 1px solid #ebeef5;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 12px 8px;

  .all-albums-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 8px 8px;

    .header-title {
      font-size: 14px;
      font-weight: 600;
      color: #303133;
    }

    .header-actions {
      display: flex;
      align-items: center;
      gap: 4px;

      .header-icon {
        font-size: 16px;
        color: #909399;
        padding: 4px;
        border-radius: 4px;
        cursor: pointer;

        &:hover {
          color: #409eff;
          background: #ecf5ff;
        }
      }
    }
  }

  .folder-tree {
    margin-top: 8px;
  }

  .move-dialog {
    max-height: 420px;
    overflow-y: auto;
  }

  .move-root,
  .move-tree-node {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 10px;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background: #ecf5ff;
      color: #409eff;
    }

    &.active {
      background: #ecf5ff;
      color: #409eff;
      font-weight: 600;
    }
  }

  .move-root {
    margin-bottom: 6px;
  }

  .move-tree {
    margin-top: 8px;
  }

  .share-tab-wrap {
    min-height: 360px;
  }

  .share-card {
    height: 100%;
  }

  .share-card-title {
    font-size: 14px;
    font-weight: 600;
  }

  .share-selected-tip {
    padding: 0 0 10px;
    font-size: 13px;
    color: #909399;
  }

  .share-target-list,
  .share-user-list,
  .share-user-select-wrap,
  .share-record-list {
    max-height: 260px;
    overflow-y: auto;
  }

  .share-target-item,
  .share-user-item {
    padding: 8px 0;
    border-bottom: 1px solid #ebeef5;
  }

  .share-user-select-title {
    margin-top: 8px;
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 600;
    color: #606266;
  }

  .share-record-main {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .share-record-name {
    font-size: 14px;
    color: #303133;
  }

  .share-record-sub,
  .share-user-sub {
    font-size: 12px;
    color: #909399;
  }

  .share-footer-btn {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
  }

  .flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .tree-node {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    min-width: 0;
    padding-right: 4px;
  }

  .tree-node-label {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;

    .tree-folder-icon {
      color: #409eff;
    }
  }

  .more-btn {
    display: flex;
    align-items: center;
    padding: 2px;
    color: #c0c4cc;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
    visibility: hidden;

    &:hover {
      color: #409eff;
      background: #ecf5ff;
    }
  }

  .tree-node:hover .more-btn {
    visibility: visible;
  }
}

/* ================= 右侧主内容区 ================= */
.main {
  flex: 1;
  min-width: 0;
  min-height: 0;
  padding: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.toolbar,
.action-bar,
.view-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* 批量管理操作栏 */
.batch-action-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fff;

  .batch-selected-tip {
    font-size: 12px;
    color: #909399;
  }
}

/* 网格卡片：固定卡片尺寸，超出容器高度时纵向滚动 */
.card-grid {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 16px;
  min-height: 0;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.card-grid .material-card {
  flex: 0 0 220px;
  width: 220px;
}

/* 专辑卡片 */
.album-card {
  position: relative;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }

  .album-tag {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 1;
    padding: 2px 8px;
    font-size: 12px;
    color: #fff;
    background: #409eff;
    border-radius: 4px;
  }

  .album-cover {
    height: 130px;
    background: #f5f7fa;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .album-name {
    padding: 10px 12px 4px;
    font-size: 14px;
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .album-meta {
    padding: 0 12px 12px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #909399;

    .meta-count {
      color: #409eff;
      font-weight: 600;
    }
  }
}

/* 素材卡片 */
.material-card {
  position: relative;
  flex: 0 0 220px;
  width: 220px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }

  &.is-selected {
    border-color: #409eff;
    box-shadow: 0 0 0 1px #409eff;
  }

  .material-check {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 2;
  }

  .material-cover {
    position: relative;
    aspect-ratio: 16 / 10;
    width: 100%;
    background: #f5f7fa;
    overflow: hidden;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
      background: #f5f7fa;
    }

    .material-duration {
      position: absolute;
      right: 6px;
      bottom: 6px;
      padding: 2px 6px;
      font-size: 12px;
      color: #fff;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 4px;
    }
  }

  .material-info {
    padding: 10px 12px;
    min-height: 62px;
    box-sizing: border-box;

    .material-name {
      font-size: 14px;
      line-height: 20px;
      color: #303133;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .material-meta {
      display: block;
      margin-top: 6px;
      min-height: 18px;
      line-height: 18px;
      font-size: 12px;
      color: #909399;
      white-space: nowrap;
      overflow: visible;
    }
  }
}

// .pagination {
//   display: flex;
//   justify-content: flex-end;
//   padding-top: 8px;
// }

.table-cover {
  width: 100%;
  aspect-ratio: 16 / 10;
  object-fit: contain;
  border-radius: 4px;
  background: #f5f7fa;
  display: block;
}

.table-cover-large {
  height: 84px;
}
</style>
